<template>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" @click="goBack()" aria-hidden="true">×</button>
                <h4 class="modal-title">{{ $t('deals_import') }}</h4>
            </div>
            <div class="modal-body form-horizontal">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
    import RoutedModals from 'utils/mixins/routed-modals'

    export default {
        name: 'IncomingImport',
        mixins: [ RoutedModals ]
    }
</script>



// WEBPACK FOOTER //
// src/modules/incoming/components/import/Main.vue